import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const AdminDashboard = () => {
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const response = await axios.get(`${window.REACT_APP_API_ENDPOINT}/api/admin/metricas`, { withCredentials: true });
                setMetrics(response.data);
            } catch (err) {
                setError('Error al cargar métricas.');
            } finally {
                setLoading(false);
            }
        };

        fetchMetrics();
    }, []);

    if (loading) return <div className="p-4">Cargando...</div>;
    if (error) return <div className="p-4 text-red-500">{error}</div>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">📊 Panel de Administración</h1>
            <div className="mb-6">
                <Link
                    to="/admin/agent-stats"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
                >
                    🤖 Estadísticas del Agente IA
                </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <Card title="Propiedades" value={metrics.totalPropiedades} />
                <Card title="Usuarios" value={metrics.totalUsuarios} />
                <Card title="Favoritos" value={metrics.totalFavoritos} />
                <Card title="Visitas" value={metrics.totalVisitas} />
                <Card title="Reformas" value={metrics.totalReformas} />
                <Card title="Indicadores" value={metrics.totalIndicadores} />
                <Card title="Licencias Vacacional" value={metrics.totalVacacional} />
                <Card title="Última fecha de cálculo" value={new Date(metrics.ultimaFechaCalculo).toLocaleString()} />
                <Card title="Última propiedad" value={`ID ${metrics.ultimaPropiedad?.id}`} />
            </div>
        </div>
    );
};

const Card = ({ title, value }) => (
    <div className="bg-white p-4 shadow rounded border border-gray-200">
        <h2 className="text-gray-600 text-sm font-semibold">{title}</h2>
        <div className="text-xl font-bold mt-2">{value}</div>
    </div>
);

export default AdminDashboard;
